var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5593 0.619936L15.6233 3.09505L13.2307 1.16554L10.7609 3.09505L8.40295 0.847186L5.98327 3.09505L3.82102 0.619935L3.82102 20.3467L18.5591 20.3467L18.5593 0.619936ZM17.9428 19.7302L4.43689 19.7302L4.43689 2.26199L5.51879 3.5003L5.93721 3.97883L6.40264 3.54653L8.39682 1.69408L10.3348 3.54192L10.7201 3.90949L11.1393 3.58121L13.2228 1.95299L15.2348 3.57583L15.6308 3.89485L16.0192 3.56735L17.941 1.94761L17.9428 19.7302Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4454 12.5809L7.43138 12.5809L7.43138 11.9645L15.4454 11.9645L15.4454 12.5809Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4454 10.2964L7.43138 10.2964L7.43138 9.67992L15.4454 9.67992L15.4454 10.2964Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1 20.3467L0.349977 20.3467L0.349978 19.8409L22.1 19.8409L22.1 20.3467Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/Receipt.d57b86b100a6c5cf7768355703bfd503.svg";
export { ForwardRef as ReactComponent };